var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5856_50534)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5856_50534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 32H5C4.45 32 4 32.45 4 33V35C4 35.55 4.45 36 5 36H25C25.55 36 26 35.55 26 35V33C26 32.45 25.55 32 25 32ZM34.825 10.7063L29.7625 5.64375C29.375 5.25625 28.7375 5.25625 28.35 5.64375L27.6437 6.35C27.2562 6.7375 27.2562 7.375 27.6437 7.7625L30 10.1188V14C30 15.7563 31.3062 17.2062 33 17.45V27.5C33 28.325 32.325 29 31.5 29C30.675 29 30 28.325 30 27.5V25.5C30 22.4625 27.5375 20 24.5 20H24V8C24 5.79375 22.2062 4 20 4H10C7.79375 4 6 5.79375 6 8V30H24V23H24.5C25.8813 23 27 24.1187 27 25.5V27.2375C27 29.5937 28.6875 31.7375 31.0312 31.9813C33.7188 32.25 36 30.1375 36 27.5V13.5375C36 12.475 35.575 11.4563 34.825 10.7063ZM20 16H10V8H20V16Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5856_50534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 32H5C4.45 32 4 32.45 4 33V35C4 35.55 4.45 36 5 36H25C25.55 36 26 35.55 26 35V33C26 32.45 25.55 32 25 32ZM34.825 10.7063L29.7625 5.64375C29.375 5.25625 28.7375 5.25625 28.35 5.64375L27.6437 6.35C27.2562 6.7375 27.2562 7.375 27.6437 7.7625L30 10.1188V14C30 15.7563 31.3062 17.2062 33 17.45V27.5C33 28.325 32.325 29 31.5 29C30.675 29 30 28.325 30 27.5V25.5C30 22.4625 27.5375 20 24.5 20H24V8C24 5.79375 22.2062 4 20 4H10C7.79375 4 6 5.79375 6 8V30H24V23H24.5C25.8813 23 27 24.1187 27 25.5V27.2375C27 29.5937 28.6875 31.7375 31.0312 31.9813C33.7188 32.25 36 30.1375 36 27.5V13.5375C36 12.475 35.575 11.4563 34.825 10.7063ZM20 16H10V8H20V16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_fn_5856_50534)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.95232,
    cy: 35.8181,
    rx: 17.7621,
    ry: 37.8547,
    transform: "rotate(-30 7.95232 35.8181)",
    fill: "url(#paint0_linear_5856_50534)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_fn_5856_50534)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.3629,
    cy: 4.46494,
    rx: 20.6853,
    ry: 34.9519,
    transform: "rotate(-173.894 42.3629 4.46494)",
    fill: "#FF5E00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_fn_5856_50534",
    x: -28.9375,
    y: -10.6553,
    width: 73.7812,
    height: 92.9468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_5856_50534"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_5856_50534",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_5856_50534"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_5856_50534"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_fn_5856_50534",
    x: 8.95898,
    y: -42.8594,
    width: 66.8086,
    height: 94.6489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_5856_50534"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_5856_50534",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_5856_50534"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_5856_50534"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5856_50534",
    x1: 30.0288,
    y1: 25.9276,
    x2: 5.01203,
    y2: 39.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5856_50534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon41);
export default __webpack_public_path__ + "static/media/caseIcon41.62b1aebc58f60d424b67f544c8d1ebe8.svg";
export { ForwardRef as ReactComponent };